module.exports = __webpack_public_path__ + "media/images/magic_modules/homepage_grid_module/hgm_pattern-3-d53c69c6770ec02a77e7a11def1ebe9e.png";